import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useField, useFormikContext} from "formik";
import PropTypes from "prop-types";

import {numberFormat} from "../../utilities/moneyFormat";

const InputWithMeasureUnits = ({
  label,
  name,
  width = "75%",
  measureUnitsList,
  labelWrap,
  onSelect = () => {},
  children,
  setref,
  fieldsWrap,
  generalWrap,
  readOnly = false,
  unitSelectDisabled = false,
  isVolumeInM3 = false,
  isWeightInKg = false,
}) => {
  const [viewSelect, setViewSelect] = useState(false);
  const [measureUnit, setMeasureUnit] = useState(null);
  // const [prevMeasureUnit, setPrevMeasureUnit] = useState(null);

  const [field] = useField(name);

  const {setFieldValue, values} = useFormikContext();

  // const arrayChildren = Children.toArray(children);

  // const staticUnit = useMemo(()=>{
  //   return Object.keys(measureUnitsList)[0]
  // },[measureUnitsList])

  const converterFunc = () => {
    if (measureUnit && !values[name]) {
      // setFieldValue(coef, measureUnit.multiplier);
      setFieldValue(name, measureUnit.value);
      // Children.map(arrayChildren, (child, index) => {
      //   if (values[child.props.name] && values[child.props.name] !== "") {
      //     var result = (+initialValues[index] / prevMeasureUnit.multiplier) * measureUnit.multiplier;
      //     setFieldValue(child.props.name, result);
      //   }
      // });

      // setPrevMeasureUnit(measureUnit);
    }
  };

  useEffect(converterFunc, [measureUnit?.value]);

  useEffect(() => {
    if (!values[name] || values[name] === "") {
      setMeasureUnit(isVolumeInM3 ? measureUnitsList[3] : isWeightInKg ? measureUnitsList[1] : measureUnitsList[0]);
      // setPrevMeasureUnit(measureUnitsList[0]);
    }
  }, [JSON.stringify(measureUnitsList ?? [])]);

  useEffect(() => {
    if (field?.value !== measureUnit?.value) {
      const unit = measureUnitsList.find(unit => unit.value === field.value);
      if (unit) {
        setMeasureUnit(unit);
        // setPrevMeasureUnit(unit);
      }
    }
  }, [field.value]);

  const setOpen = useCallback(() => {
    if (measureUnitsList.length !== 0) {
      setViewSelect(true);
    }
  }, [measureUnitsList]);

  const close = useCallback(() => {
    setViewSelect(false);
  }, [measureUnitsList]);

  const showOptions = useCallback(e => {
    if (
      e.target.className === "select__list_container" ||
      e.target.className === "select_option" ||
      e.target.className === "select__list_button"
    ) {
      close();
    }
  }, []);

  const generateSelect = useCallback(
    options => {
      if (options) {
        var liList = [];
        options.forEach((option, i) => {
          liList.push(
            <li
              className="select_option"
              key={i + 1}
              onClick={() => {
                setMeasureUnit(option);
                onSelect(option);
                setFieldValue(name, option.value);
                // setPrevMeasureUnit(option);
              }}
            >
              {option.title}
            </li>,
          );
        });
      }
      return liList;
    },
    [measureUnitsList, name, onSelect, setFieldValue],
  );

  const optionsLi = useMemo(() => generateSelect(measureUnitsList), [measureUnitsList]);

  return (
    <div
      className={"inputWithMeasureUnits " + `${fieldsWrap ? "fieldWithSample__wrap" : ""}`}
      style={{
        display: "flex",
        width: "100%",
        flexWrap: generalWrap ? "wrap" : "nowrap",
      }}
    >
      <div className={`project_input ${labelWrap ? "" : "autolabel"}`}>
        {label && <label>{label}</label>}
        <div className="" style={{display: "flex", width: width + "%"}}>
          <input
            type="text"
            style={{width: "55px"}}
            onClick={() => {
              if (!readOnly) setOpen();
            }}
            value={measureUnit?.title || ""}
            readOnly={true}
          />
          <div
            className={`select__list_button ${readOnly ? "blur" : ""}`}
            readOnly={readOnly}
            onClick={() => {
              if (!readOnly && !unitSelectDisabled) setOpen();
            }}
          >
            {!readOnly && !unitSelectDisabled && "▼"}
          </div>
          {viewSelect && !unitSelectDisabled ? (
            <div
              className="select__list_container"
              style={{width: "80px", paddingTop: "-20px"}}
              onClick={e => showOptions(e)}
              onMouseLeave={close}
            >
              <div className="select__list disable " style={{width: "100%"}}>
                <ul>{optionsLi}</ul>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="additional_inputs">
        {React.Children.map(children, child => {
          return <MeasureUInput coef={measureUnit?.multiplier} {...child.props} setref={setref} readOnly={readOnly} />;
        })}
      </div>
    </div>
  );
};

InputWithMeasureUnits.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  name: PropTypes.string,
  width: PropTypes.string,
  measureUnitsList: PropTypes.array,
  children: PropTypes.node,
};
export default InputWithMeasureUnits;

const MeasureUInput = ({
  label,
  name,
  width,
  coef,
  isInt = false,
  setref,
  precision = 2,
  noFormat = false,
  simpleZero = false,
  ...props
}) => {
  const {setFieldValue, values} = useFormikContext();
  const [rawValue, setRawValue] = useState("");

  // const isZero = Number.parseFloat(rawValue) === 0;

  const inputRef = useRef(null);

  const setInputRef = ref => {
    if (ref) {
      inputRef.current = ref;
      if (setref) setref(ref);
    }
  };

  // const options = {
  //   decimal: ".",
  //   thousand: "'",
  //   precision,
  // };

  const onChange = e => {
    let value = e.target.value;
    value = value.replace(/[^\d.-]/g, "");
    if (value < 0 || value === "-") {
      return;
    }
    setRawValue(value);
  };

  const validate = () => {
    if (isInt) {
      setFieldValue(name, Number.parseInt((Number(rawValue) * 100) / (coef * 100)).toString());
    } else {
      setFieldValue(name, ((Number.parseFloat(rawValue) * 100) / (coef * 100)).toString());
    }
  };

  useEffect(() => {
    const valueWithCoef = (+values[name] * (+coef * 100)) / 100 || 0;
    // const stringValueWithCoef = String(valueWithCoef) || "";

    if (isInt) {
      if (values[name] === "") {
        setRawValue("");
      } else {
        setRawValue(Math.round(valueWithCoef));
      }
    } else {
      if (coef) {
        setRawValue(
          noFormat ? values[name] : numberFormat(valueWithCoef, precision, true),
          // : accounting.formatNumber(valueWithCoef, {
          //         ...options,
          //         precision: calcDynamicPrecision({
          //           value: stringValueWithCoef,
          //           defaultPrecision: precision,
          //           dynamicPrecision: true,
          //           simpleZero,
          //         }),
          //       }),
        );
      }
    }
  }, [coef, values[name], noFormat, precision, simpleZero]);

  const handleFocus = () => {
    inputRef?.current.select();
  };

  return (
    <div className="project_input">
      {label && (
        <label htmlFor={props.name} className={`${props.labelClassName} ${props.autolabel ? "autolabel" : ""}`}>
          {label}
        </label>
      )}
      <div className="" style={{width: width, position: "relative"}}>
        <div className={props?.className}>
          <input
            value={rawValue}
            onChange={onChange}
            style={{...props?.style, ...(props.readOnly ? {cursor: "default"} : {background: "white"})}}
            // type="number"
            onBlur={!props?.readOnly ? validate : null}
            onFocus={() => {
              !props?.readOnly && handleFocus();
            }}
            readOnly={props.readOnly}
            // type={isInt ? "number" : "string"}
            step={isInt ? "1" : "0.5"}
            ref={setInputRef}
          />
        </div>
        {/* {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null} */}
      </div>
    </div>
  );
};
